import { GET_INFO_TALENT_START } from '../../types';

export const get_info_talent = (payload) => ({
  type: GET_INFO_TALENT_START,
  payload,
});
